"use client";

import { AppPageTitle } from "@/widgets";
import InquiryFormSection from "@/widgets/app/page/inquiry/InquiryFormSection";
import { SsgoiTransition } from "@ssgoi/react";

export default function InquiryPage() {
  return (
    <SsgoiTransition id="/app/pages/inquiry">
      <div className="max-[991px]:pt-16 flex pt-24 w-full flex-col">
        <AppPageTitle />
      </div>

      <div className="w-full flex-col">
        <InquiryFormSection />
      </div>
    </SsgoiTransition>
  );
}
